import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import FolderIcon from '@mui/icons-material/Folder';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import PersonIcon from '@mui/icons-material/Person';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import { logoutUser } from '../../actions/userAction';

const SidebarTab = ({ icon: Icon, label, to, active, onClick }) => {
    return (
        <div className={`flex items-center gap-5 px-4 py-4 ${active ? 'bg-blue-50 text-primary-blue' : 'text-gray-500 hover:bg-blue-50 hover:text-primary-blue'}`}>
            <span className="text-primary-blue"><Icon /></span>
            <Link className="flex w-full justify-between font-medium" to={to} onClick={onClick}>
                {label}
                {active && <span><ChevronRightIcon /></span>}
            </Link>
        </div>
    );
};

const Sidebar = ({ activeTab }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const { user } = useSelector(state => state.user);

    const handleLogout = () => {
        dispatch(logoutUser());
        enqueueSnackbar('Logout Successfully', { variant: 'success' });
        navigate('/login');
    };

    return (
        <div className="hidden sm:flex flex-col gap-4 w-1/4 px-1">

            {/* Profile Card */}
            <div className="flex items-center gap-4 p-3 bg-white rounded-sm shadow">
                <div className="w-12 h-12 rounded-full">
                    <img draggable="false" className="h-full w-full object-cover rounded-full" src={user.avatar.url} alt="Avatar" />
                </div>
                <div className="flex flex-col gap-1">
                    <p className="text-xs">Hello,</p>
                    <h2 className="font-medium">{user.name}</h2>
                </div>
            </div>

            {/* Navigation Tabs */}
            <div className="flex flex-col bg-white rounded-sm shadow">
                {/* My Orders Tab */}
                <SidebarTab icon={FolderIcon} label="MY ORDERS" to="/orders" active={activeTab === "orders"} />

                {/* Account Settings Tab */}
                <SidebarTab icon={PersonIcon} label="ACCOUNT SETTINGS" to="/account" active={activeTab === "profile"} />

                {/* My Stuff Tab */}
                <SidebarTab icon={FolderSharedIcon} label="MY STUFF" to="/wishlist" active={activeTab === "wishlist"} />

                {/* Logout Tab */}
                <div className="flex items-center gap-5 px-4 py-4 border-t">
                    <span className="text-primary-blue"><PowerSettingsNewIcon /></span>
                    <div className="flex w-full justify-between font-medium text-gray-500 hover:text-primary-blue cursor-pointer" onClick={handleLogout}>
                        Logout
                        <span><ChevronRightIcon /></span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;
